import RightChevron from "@src/assets/icons/RightChevron";
import { PREVIOUS_PATH_KEY } from "@src/constants/sessionStorage-constants";
import Image from "next/image";
import { useRouter } from "next/router";

interface Props {
  links: {
    label: string;
    route: string;
    active?: boolean;
  }[];
  backButton?: {
    label?: string;
    onClick?: () => void;
  };
}

export default function Breadcrumbs(props: Readonly<Props>) {
  const { links, backButton } = props;
  const router = useRouter();
  const useSmartBack = () => {
    const router = useRouter();

    return () => {
      const previousPath = sessionStorage.getItem(PREVIOUS_PATH_KEY);

      const isInternal = previousPath?.startsWith("/");
      const isLoginPage = previousPath === "/login";

      if (isInternal && !isLoginPage) {
        router.push(previousPath);
      } else {
        router.push("/");
      }
    };
  };
  const handleSmartBack = useSmartBack();

  return (
    <div className="self-stretch h-[22px] flex-col font-nunito justify-start items-start flex">
      <div className="flex items-center gap-3">
        {backButton && (
          <button
            onClick={backButton.onClick ?? handleSmartBack}
            className="flex items-center gap-1 text-sm text-afya-aqua-300 bg-afya-aqua-100 transition-colors font-medium rounded-md px-3 py-2"
          >
            <Image src={"/arrow.svg"} alt={"back"} width={12} height={10} className="mr-1" />
            {backButton.label ?? "Voltar"}
          </button>
        )}

        {links.map((link, index) => (
          <div className="flex items-center" key={`${index}-${link.label}`}>
            <button
              onClick={() => router.push(link.route)}
              className="pr-3 justify-start items-start gap-px flex cursor-pointer"
            >
              <div
                className={`text-sm leading-tight ${
                  link.active ? "text-neutral-900 font-bold" : "text-neutral-400 font-normal"
                }`}
              >
                {link.label}
              </div>
            </button>
            {index + 1 !== links.length && (
              <div className="text-slate-400 text-sm font-medium leading-snug">
                <RightChevron />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
